import moment from "moment";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

import { Spinner } from "react-bootstrap";

export const CustomModal = (props: any) => {
  const {PickupChangeRequired = "false"} = props;
  const { t } = useTranslation();
  return (
    <>
      <Modal as={Modal.Dialog} centered show={props.show} onHide={props.close}>
        <Modal.Header>
          <Modal.Title className='h6'>{props.Title}</Modal.Title>
          <Button variant='close' aria-label='Close' onClick={props.close} />
        </Modal.Header>
        <Modal.Body>
          {props.Message}
          {(() => {
            if (typeof props.ListChange != 'undefined' && props.PickupChangeRequired=='true' && props.ListChange.length>0) {
              return(
                <><hr /><Modal.Title className='h6'>{props.MessageChange}</Modal.Title><hr /></>
                )
            }

        })()}

        {(() => {
          if (typeof props.ListChange != 'undefined' && props.PickupChangeRequired=='true' && props.ListChange != null) {
              return(
                props.ListChange.map((data) => (
                  <div key={data.branchId}> 
                    <label>
                      <input id= {'cardId__' + data.idEquipment + '__' + moment(data.pickupDate).format('YYYY-MM-DD')}  type="checkbox" onChange={props.checkValue} />
                      &nbsp;
                      {t('SAFE') + ': ' + data.codeEquipment + ' ' +  data.clientComercialName} 
                    </label>
                  </div>
                ))
              )
            }
        })()}

        </Modal.Body>
        <Modal.Footer>
          {props.children}
          <Button
            disabled={props.isLoading || false}
            variant='link'
            className='text-gray ms-auto'
            onClick={props.close}>
            {props.isLoading && (
              <Spinner animation="border" size="sm" />
            )}  
            {props.cancel}
        </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
